<template>
  <div class="d-flex crds-container">
    <div
      v-for="(vendor, index) in data"
      class="d-flex crd-container"
      :key="'vendor-' + index"
    >
      <Card
        :removeHeaderBoundry="true"
        :headerStyle="{ 'border-bottom': 'none' }"
      >
        <template #card-body>
          <div class="d-flex flex-column">
            <div class="img-cntr">
              <img class="svc-img" :src="loadImg(vendor.icon)" />
            </div>
            <div class="svc-name">
              <h4>{{ vendor.title }}</h4>
            </div>
            <div class="svc-desc">
              <span>{{ vendor.subtitile }}</span>
            </div>
            <div class="d-flex justify-content-end" v-if="hasWritePermission">
              <RexButton
                :styling="{
                  'min-height': '2.5rem',
                  height: 'auto',
                  width: 'fit-content',
                  border: '0px',
                }"
                :id="'cloud-integration-btn-' + index"
                :variant="vendor.isActive == 1 ? 'tertiary' : 'disabled'"
                @onClick="() => onInstall(vendor.name)"
              >
                {{ vendor.isActive == 1 ? $t('configure') : $t('soon') }}
              </RexButton>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>
<script>
import Card from '@/rex-components/rex-card.vue';
import RexButton from '@/rex-components/rex-button';
import { config } from './util';
import { mapGetters } from 'vuex';
import { INTEGRATIONS_RESOURCE_GROUP } from '@/router/constant';
import { usePermissions } from '@/hooks/usePermissions';

export default {
  components: { Card, RexButton },
  props: {
    viewType: {
      type: String,
      required: true,
      default: config.VIEW_TYPE.INSTALLED,
    },
    data: { type: Array, default: () => [] },
  },
  methods: {
    onInstall(svcName) {
      this.$emit('onInstall', svcName);
    },
    loadImg(imgName) {
      if (!imgName) return;
      return require(`../../../assets/img/${imgName}`);
    },
  },
  mounted() {},
  computed: {
    config() {
      return config;
    },
    hasWritePermission() {
      const { hasCapabilityWritePermission } = usePermissions();

      return hasCapabilityWritePermission(INTEGRATIONS_RESOURCE_GROUP);
    },
  },
};
</script>
<style lang="css" scoped>
.svc-desc {
  padding-left: 1%;
  padding-right: 1%;
}
.svc-name,
.svc-desc {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.crd-container {
  margin: 1rem;
  max-width: 25rem;
}
.crds-container {
  flex-wrap: wrap;
}
.svc-img {
  height: 10rem;
  width: auto;
}
</style>
